export enum YN {
  'YES' = 'Y',
  'NO' = 'N',
}

export const CONST_YN = Object.values(YN);
